export default {
  // ContinueWithEmail / SignIn / SignUp
  signInToYour: `SIGN IN TO YOUR`,
  signInToUse: `SIGN IN TO USE`,
  createAnAccount: `CREATE AN ACCOUNT`,
  createYour: `CREATE YOUR`,
  createAccountFor: `CREATE AN ACCOUNT FOR`,
  tmAccount: `Trend Micro Account`,
  toStartFreeTrial: `TO START YOUR 30-DAY FREE TRIAL`,
  toStartUsing: `TO START USING`,
  newUser: `New user?`,
  createAccount: `Create an account`,
  email: `Email address`,
  password: `Password`,
  confirmPassword: `Confirm password`,
  signIn: `Sign In`,
  alreadyHaveAccount: `Already have an account?`,
  forgotEmail: `Forgot which address you used before?`,
  forgetPassword: `Forgot your password?`,
  incorrectEmailPassword: `Incorrect email address or password`,
  emailOrPhone: `Email address or mobile phone number (numbers only)`,
  next: `Next`,
  noAccountYet: `No account yet?`,
  createNewAccount: `Create Account`,
  continueWithOtherOptions: `Or continue with other options`,
  continueAs: `Continue as {account}`,
  continueWithOTP: `Continue with one-time confirmation code`,
  signUpAs: `Sign up as {account}`,
  signUpWithSocialGoogle: `Sign up with Google`,
  signUpWithSocialApple: `Sign up with Apple`,
  signInWithSocialGoogle: `Sign in with Google`,
  signInWithSocialApple: `Sign in with Apple`,
  signInAs: `Sign in as {account}`,
  signInFailAs: `Unable to sign in as {account}`,
  signUpWith: `Sign up as {email} with {method}`,
  signInWith: `Sign in as {email} with {method}`,
  signInFailWith: `Unable to sign in as {email} with {method}`,
  signUpWithGoogle: `Sign up as {email} with {method}`,
  signInWithGoogle: `Sign in as {email} with {method}`,
  signInFailWithGoogle: `Unable to sign in as {email} with {method}`,
  signInWithEmailOTP: `Sign in with one-time confirmation code`,
  usePasswordInstead: `Use password instead`,
  useAnotherEmail: `Use another email address`,
  useAnotherPhoneNumber: `Use another mobile phone number`,
  useAnotherSignInMethod: `Use another sign in method`,
  useAnotherSignUpMethod: `Use other sign up methods`,
  useAnotherMethod: `Use another method`,
  show: `Show`,
  hide: `Hide`,
  phoneNumberFrom: `Is the phone number from {country} (+{phoneCode})?`,
  selectCountry: `Select the country for this mobile phone number`,
  sendSMSCode: `We will send you a one-time confirmation code to your mobile phone number.`,
  verifyCode: `To verify your identity, provide the confirmation code we sent to your mobile phone number.`,
  verifyEmailCode: `To verify your identity, provide the confirmation code we sent to your {email}.`,
  confirmationCode: `Confirmation code`,
  haveSameEmail: `You already have a Trend Micro Account with the same email address.`,
  enterYourPassword: `Enter your Trend Micro Account password`,
  accountLinking: `Enter your Trend Micro Account password to link your account and continue to sign in quickly and safely.`,
  completeProfile: `Complete your profile to enjoy a more personalized experience.`,
  firstName: `First name`,
  lastName: `Last name`,
  phoneNumber: `Phone number`,
  receiveNews: `Receive latest news and offers from Trend Micro`,
  maybeLater: `Maybe later`,
  chooseAccount: `Choose the account to sign in with`,
  troubleSignIn: `Trouble signing in?`,
  accountDuplicate: `An account with this email address already exists. Use another email, or
  <span id="linkSignIn" class="link-tag">sign in with this email</span>.`,
  emailAccountIsExisted: `It looks like you created an account with this email address already.`,
  emailAccountIsNotExisted: `It looks like you haven’t created an account yet or this email address isn’t correct.`,
  smsAccountIsExisted: `It looks like you created an account with this phone number already.`,
  smsAccountIsNotExisted: `It looks like you haven’t created an account yet or this phone number isn’t correct.`,
  signInWithThisEmail: `Sign in with this email`,
  signUpWithThisEmail: `Create a new account with this email`,
  signInWithThisSMS: `Sign in with this number`,
  signUpWithThisSMS: `Create a new account with this number`,
  accountNotExist: `There is no account with this email address. Use another email, or <span id="linkSignUp" class="link-tag">create an account with this email</span>.`,
  phoneAccountDuplicate: `An account with this number already exists. Use another mobile phone number, or <span id="linkSignIn" class="link-tag">sign in with this mobile phone number</span>.`,
  phoneAccountNotExist: `There is no account with this number. Use another mobile phone number, or <span id="linkSignUp" class="link-tag">create an account with this mobile phone number</span>.`,
  signInUnsuccess: `Sign in unsuccessful`,
  noPasswordLoginInstruction: `You haven’t set a password for your account yet. To set your password, follow the “Forgot Your Password?” instructions on the next screen.`,
  signInWithPhone: `Sign in with mobile phone number instead`,
  accountNotCreated: `Looks like there is no account with this email address.`,
  createAccountOrSignIn: `Continue to create an account, or if you already have an account, <span id="linkChangeMethod" class="link-tag">use another sign in method</span>.`,
  createAccountFailed: `Create account unsuccessful`,
  googleAccountExisted: `An account with this Google ID already exists. Try using a different account.`,
  appleAccountExisted: `An account with this Apple ID already exists. Try using a different account.`,
  emailAccountExisted: `An account with this email address already exists. Please use another email.`,
  smsAccountExisted: `An account with this number already exists. Please use another mobile phone number.`,
  googleAccountNotExised: `Looks like there is no account with this Google ID. Try another account or use another method.`,
  appleAccountNotExised: `Looks like there is no account with this Apple ID. Try another account or use another method.`,
  emailAccountNotExisted: `There is no account with this email address. Please use another email.`,
  smsAccountNotExisted: `There is no account with this number. Please use another mobile phone number.`,
  acceptAgreement: `I have read and accept the {agreement1} and {agreement2}`,

  // Error Messages
  incorrectPassword: `Incorrect password`,
  incorrectCode: `Check if the confirmation code is correct, or choose Resend to request a new code.`,
  socialLoginFail: `Looks like your account information doesn’t match. Try using a different account.`,

  // TwoFactorAuth
  twoFactorAuth: `Two-factor Authentication`,
  verifyAuthApp: `To verify your identity, provide the confirmation code in your authentication app.`,
  verifySms: `To verify your identity, provide the confirmation code sent to {userSms}.`,
  verifyEmail: `To verify your identity, provide the confirmation code sent to {userEmail}.`,
  notReceiveCode: `Did not receive a code?`,
  upperContactSupport: `Contact support.`,
  upperChooseAnotherMethod: `Choose another method.`,
  resend: `Resend`,
  or: `or`,
  lowerContactSupport: `contact support.`,
  lowerChooseAnotherMethod: `choose another method.`,
  codeSent: `Code sent.`,

  // ChooseAnotherMethod
  selectMethod: `Select a Method`,
  authApp: `Authentication App`,
  receiveAuthApp: `Receive confirmation codes via your authentication app.`,
  sms: `Text Message (SMS)`,
  receiveSms: `Receive confirmation codes via {userSms}.`,
  emailAddress: `Email address`,
  receiveEmailAddress: `Receive confirmation codes via {userEmail}.`,
  continue: `Continue`,

  doUse: `Do Use`,
  dontUse: `Don't Use`,
  labelOK: `OK`,
  contactSupport: `Need help? <a id="contactSupport" class="link-tag">Contact support</a>`,

  validationRules: {
    birthDayIncorrect: "The format of birth day is incorrect.",
    birthMonthIncorrect: "The format of birth month is incorrect.",
    birthYearIncorrect: "The format of birth year is incorrect.",
    CHECK_EMAIL: "Use a valid email format.",
    CHECK_MERGE_EMAIL: "Please provide an email address in the correct format.",
    CHECK_MERGE_SN: "Please provide the correct serial number and password for your account.",
    CHECK_PASSWORD_LENGTH: "The password should have between 8 and 50 characters.",
    CHECK_PASSWORD_FORMAT: "Your password must include between 8 and 50 characters. Letters, numbers, and the special symbols {PASSWORDSYMBOLS} are allowed.",
    PASSWORD_LENGTH_FAIL: "Your password must have 8 to 50 characters.",
    PASSWORD_COMPLEXITY_FAIL: `Avoid common words, names, and characters that are next to each other like “qwerty”`,
    checkFax: "The format of the fax is invalid.",
    checkFirstName: "Please type only letters of the alphabet here.",
    checkLastName: "Please type only letters of the alphabet here.",
    checkPhone: "The format of the phone is invalid.",
    checkZipCode: "The format of the ZipCode is invalid.",
    EMAIL_NOT_MATCH: "The email addresses do not match.",
    FIELD_REQUIRED: "Please fill out this field.",
    PASSWORD_NOT_MATCH: "Passwords do not match. Please try again.",
    snIncorrect: "The specified serial number or password is invalid.",
  },
  passwordRules: {
    title: `Your password should have:`,
    rule1: `8 to 50 characters`,
    rule2: `Uppercase & lowercase letters`,
    rule3: `At least one special character and number`,
    rule4: `No characters that are next to each other like “qwerty”`,
    tip: `How do I create a strong password?`
  },
  passwordTips: {
    title: `How do I create a strong password?`,
    tipMsg: `Follow these tips to create a password that’s easy to remember but tough to crack.`,
    tipGood1: `A meaningful phrase from a book, a song, etc.`,
    tipGood2: `Unrelated words, numbers, and special characters`,
    tipBad1: `Common words or phrases like "password" or "let me in"`,
    tipBad2: `A sequence of characters like "abcd" or "1234"`,
    tipBad3: `Characters that are next to each other like "qwerty"`,
    example: `For example, turn the phrase “all the single ladies raise your hands” into “L@dies-5ingle-Raise-Hands!”`,
  },
  passwordStrength: {
    description: {
        good: "Add more random letters, numbers, and symbols to make your password stronger.",
        short: "The password should have between 8 and 50 characters.",
        strong: "To keep your password secure, do not share it with others or online.",
        weak: "A strong password should be between 8 and 50 characters, and include a random mix of letters, numbers, and symbols."
    },
    level: {
        good: "Good",
        short: "Too short",
        strong: "Strong",
        weak: "Weak"
    }
  },
  emailVerification: {
    linkExipredTitle: `This link has already expired`,
    linkExipredContent: `Click the button below to get another verification email.`,
    btnResendVerificationMail: `Resend verification email`,
    linkSentTitle: `We sent an email to:`,
    linkSentContent: `Please follow the instructions in the email to verify your email address. If you don’t see the email, don’t forget to check your spam or junk mail folder.`,
    didnotReceiveEmail: `Didn’t receive the email?`,
    verifySuccessTitle: `Your email address has been verified:`,
    verifySuccessContent: `You can go back and continue what you were doing.`,
    verifyLater: `Verify later`,
    verifyEmailAddrTitle: `Verify your email address:`,
    verifyEmailAddrContent: `To verify you are the owner of this email address, provide the confirmation code or click the link we sent to your email.`,
  },

  errorMsg: {
    serverError: `Oops, the server is busy`,
  }
};
